import React, {  useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import AuthenticationManager from '../../services/StorageJWT';
import profileAPI from '../../api/profileAPI';
import PopupBox from '../../components/PopupBox';
import { Button, Spinner } from 'react-bootstrap';
import MasterPage from '../../layouts/MasterPage';

const Properties = () => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [errorText, setErrorText] = useState('');
  const [show, setShow] = useState(false);
  const [jwt, setJwt] = useState({});
  var _auth= new AuthenticationManager();
  const navigate = useNavigate();
  useEffect(() => {
   
    setJwt(_auth._token);
    // try {
      if(_auth?._token.user.email)
      setEmail(_auth?._token.user.email)
      if(_auth?._token.user.name)
      setName(_auth?._token.user.name)
    // } catch {
      // navigate('/');
    // }
  }, []);
 
  const onSubmit = () => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if ( email && !re.test(email) ) {
   
      setShow(true);
      setErrorText("ایمیل وارد شده صحیح نمی باشد");
      return;
    }
    if (name !== '' || code !== '') {
      setError(true);
      profileAPI
        .updateProfile({ code: code, name: name, email: email }, jwt)
        .then((res) => {
          _auth.updateProfile(res);
          navigate('/menu/assist',{state:{prePage:"properties"}});
        })
        .catch((e) => {
          if (e.response) {
            if (e.response.data.error) {
              setShow(true);
              setErrorText(e.response.data.error);
            }
          }
        })
        .finally(() => setLoading(false));
    } else setError(true);
  };
  return (
    <MasterPage>
      <div
        className="structure-page-2 login p-3 body "
      >
          <h6 >ثبت مشخصات</h6>
        <div className="text-center w-100">
        

          <div className="form-group mt-3 mb-2 w-100">
            <label htmlFor="name" className='w-100'>
              نام و نام خانوادگی <span className="text-danger">*</span>
          
            <input
              onChange={(e) => setName(e.target.value)}
              type="text"
              value={name}
              className={`form-control w-100 ${
                !name && error ? 'is-invalid' : ''
              }`}
              placeholder="تایپ کنید"
            />
              </label>
          </div>
          <div className="form-group mb-2">
            <label htmlFor="name" className='w-100'>آدرس ایمیل 
            <input
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              type="email"
              className="form-control w-100"
              placeholder="Email Address"
            />
            </label>
          </div>
          <div className="form-group  mb-2">
            <label htmlFor="name" className='w-100'>
              کد اختصاصی بازی  <span className="text-danger">*</span>
       
            <input
              onChange={(e) => setCode(e.target.value)}
              type="text"
              className={`form-control w-100 ${
                !code && error ? 'is-invalid' : ''
              }`}
              placeholder="تایپ کنید"
            />
                 </label>
          </div>

          <PopupBox show={show} setShow={setShow} text={errorText} />
        </div>
        <Button
          variant="dark"
          className="btn btn-submit d-flex justify-content-center  mt-4"
          onClick={onSubmit}
        >
          {loading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              className="p-2"
              role="status"
              aria-hidden="true"
            />
          ) : (
          <span className='mt-1'> ثبت</span>
          )}
        </Button>
      </div>
    </MasterPage>
  );
};

export default Properties;
